import { ReactNode } from 'react';

export enum CriteriaCardType {
  INDEX_DATE = 'INDEX DATE',
  CLINICAL = 'CLINICAL',
  DEMOGRAPHIC = 'DEMOGRAPHIC',
  OBSERVABILITY = 'OBSERVABILITY',
}

export enum CriteriaStatusType {
  INDEX_DATE = 'Index date',
  INCLUSION = 'Inclusion',
  EXCLUSION = 'Exclusion',
  NOT_APPLIED = 'Not applied',
  /**
   * Placeholder state for an unbound stub criterion emitted by the
   * cohort_drafter (OR-6037). Shown alongside the role chip while the
   * per-stub resolve loop is still working on attaching a concrete
   * analytical variable. Falls through to the default grey style in
   * ``getStatusColors``.
   */
  PENDING = 'Pending',
}

export type CriteriaCardDetailsItem = {
  key: string;
  value: string | ReactNode;
  onClick?: VoidFunction;
};
